import { createAuthAxios, handleApiError } from "../utils/apiUtils";
import { AUTH_ENDPOINTS } from "../config/apiConfig";

// Debounce function to prevent multiple rapid calls
let lastFetchTime = 0;
const DEBOUNCE_INTERVAL = 5000; // 5 seconds
let isCurrentlyFetching = false;

/**
 * Service for handling profile-related API operations
 */
const profileService = {
  /**
   * Get user profile data
   * @returns {Promise<Object>} User profile data
   */
  getUserProfile: async () => {
    try {
      // Check if we're already fetching - prevent concurrent calls
      if (isCurrentlyFetching) {
// Return the cached user data from localStorage
        const cachedUser = JSON.parse(localStorage.getItem("user"));
        return cachedUser;
      }

      // Implement debouncing to prevent rapid successive API calls
      const now = Date.now();
      if (now - lastFetchTime < DEBOUNCE_INTERVAL) {
// Return the cached user data from localStorage
        const cachedUser = JSON.parse(localStorage.getItem("user"));
        return cachedUser;
      }

      // Set fetching flag
      isCurrentlyFetching = true;

      lastFetchTime = now;
const authAxios = createAuthAxios();
      const response = await authAxios.get(AUTH_ENDPOINTS.PROFILE);
// Check if the response contains a user object or is the user object directly
      const userData = response.data.user || response.data;
// Reset fetching flag
      isCurrentlyFetching = false;

      return userData;
    } catch (error) {
      // Reset fetching flag even on error
      isCurrentlyFetching = false;

      const errorData = handleApiError(error);
throw errorData;
    }
  },

  /**
   * Update user profile data
   * @param {Object} profileData - Updated profile data
   * @returns {Promise<Object>} Updated user profile data
   */
  updateUserProfile: async (profileData) => {
    try {
const authAxios = createAuthAxios();
      const response = await authAxios.put(
        AUTH_ENDPOINTS.UPDATE_PROFILE,
        profileData
      );
// Reset the debounce timer after an update
      lastFetchTime = 0;

      return response.data;
    } catch (error) {
      const errorData = handleApiError(error);
throw errorData;
    }
  },
};

export default profileService;
